import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const FavoriteFill = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 20 20"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M9.20121 2.50215C9.47249 1.75612 10.5276 1.75613 10.7989 2.50215L12.5254 7.25001H17.7086C18.5179 7.25001 18.8693 8.27408 18.2304 8.77096L14.3461 11.7921L15.6627 17.0584C15.8535 17.8214 14.9949 18.4119 14.3507 17.9609L10 14.9155L5.64941 17.9609C5.00515 18.4119 4.14661 17.8214 4.33734 17.0584L5.65393 11.7921L1.76964 8.77096C1.13079 8.27408 1.48216 7.25001 2.29149 7.25001H7.47471L9.20121 2.50215Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default FavoriteFill;
